import { Component, effect, type ElementRef, input, viewChild } from '@angular/core';
import { type Config, DotLottie } from '@lottiefiles/dotlottie-web';

@Component({
  imports: [],
  selector: 'app-lotti-player',
  templateUrl: './lotti-player.html',
})
export class LottiPlayer {
  public readonly config = input<Config>({ autoplay: true, loop: false });
  public readonly source = input.required<string>();

  protected readonly canvasRef = viewChild<ElementRef>('lottieCanvas');

  private _dotLottie?: DotLottie;

  constructor() {
    effect(() => {
      if (!this.canvasRef()?.nativeElement) {
        return;
      }

      this._dotLottie = new DotLottie({
        ...this.config(),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- The lottie library is typed, but the types are not strict enough to satisfy the linter.
        canvas: this.canvasRef()?.nativeElement,
        src: this.source(),
      });
    });
  }
}
